import { graphql } from '../gql'

export const GET_ACTIVE_CUSTOMER_QUERY = graphql(`
  query GetActiveCustomer {
    activeCustomer {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
      addresses {
        id
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country {
          id
          code
          name
        }
        phoneNumber
        defaultShippingAddress
        defaultBillingAddress
      }
      customFields {
        nif
        is_sales_user
        points
        freezePoints
      }
      orders(
        options: {
          sort: { orderPlacedAt: DESC, createdAt: DESC }
          filter: { state: { notIn: ["AddingItems"] } }
        }
      ) {
        items {
          id
          code
          state
          active
          createdAt
          orderPlacedAt
          totalQuantity
          total
          totalWithTax
          currencyCode
          lines {
            id
            quantity
            productVariant {
              id
              featuredAsset {
                preview
              }
              product {
                featuredAsset {
                  preview
                }
              }
            }
          }
        }
        totalItems
      }
    }
  }
`)
